import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingScreenComponent } from './loading-screen.component';
import { TurbineComponent } from './turbine/turbine.component';

/** @deprecated Use the equivalent from `@coin/shared/core/data-access-v2` instead. */
@NgModule({
  declarations: [LoadingScreenComponent, TurbineComponent],
  imports: [CommonModule],
  exports: [LoadingScreenComponent]
})
export class LoadingModule {}
